<template>
	<div class="pending-requests">
		<h4>Pending Requests</h4>
	</div>
</template>

<script>
	import modal from '../Modal/DefaultModal.vue';

	export default {
		components: {
			modal
		},
		data() {

			return {
				currentUser: this.$currentUser,
				userRoles: this.$currentUserRoles,
				isModalVisible: false,

				currentEvent: null,
				currentEventObject: {},
				comment: '',

			}
		},
		methods: {
			fetchHrData: function () {
				let vm = this;
				axios.get('/api/hr/user/' + this.currentUser.id
				).then(function (response) {
					vm.events = response.data.events;
					vm.userDetails = response.data.user;
					vm.closeModal();
				});
			},
		}
	}
</script>

<style scoped>

</style>
